<template>
  <div class="plant-wrapper">
    <div class="plant-wrapper-top">
      <div class="handle-wrapper" @click="backPath">
        <div class="icon-font">&#xe612;</div>
        返回
      </div>
      <div class="plant-wrapper-top-title">新建虫情板</div>
      <div class="handle-wrapper" @click="handleData">
        <div class="icon-font">&#xe653;</div>
        提交
      </div>
    </div>
    <div class="plant-deal-content">
      <div class="plant-deal-content-wrapper">
        <div class="input-contain">
          <div class="input-title">虫情板ID：</div>
          <div class="input-wrapper">
            <input v-model="inputValue.pestBoardId" placeholder="" />
          </div>
        </div>
        <div class="input-contain">
          <div class="input-title">位置：</div>
          <LoadingTreeStack
            :moduleType="moduleType"
            :content="inputValue.siteName"
            :editCheckId="inputValue.siteId"
            v-on:sendInfo="showDropSite"
          ></LoadingTreeStack>
        </div>
        <div class="input-contain">
          <div class="input-title" style="margin-left: 0.83vw">负责人：</div>
          <DropDownInput
            type="1"
            :items="custodianValue"
            content=""
            @sendValue="sendValue"
            @sendInfo="showInfo"
          ></DropDownInput>
        </div>
        <div class="input-contain">
          <div class="input-title">使用时间：</div>
          <div class="input-suffix-wrapper">
            <input v-model="inputValue.useDays" placeholder="" />
            <div class="input-suffix">（天）</div>
          </div>
        </div>
      </div>
      <div class="plant-deal-content-wrapper">
        <div class="input-contain">
          <div class="input-title">虫情类型：</div>
          <div class="input-wrapper">
            <input
              @click="mouseOver"
              v-model="boardname"
              placeholder="可添加多个"
              readonly
            />
            <span
              @click="clearinputSelect"
              style="display: inline-block; width: 50px; cursor: pointer"
              >清除</span
            >
          </div>
          <DropDown
            v-show="showSelect"
            content="请选择类型"
            :items="typeData"
            v-on:sendInfo="showInfoType"
          ></DropDown>
        </div>
        <div class="input-contain">
          <div class="input-title">虫情类型：</div>
          <div class="input-wrapper">
            <input v-model="boardnameType" placeholder="输入添加的虫情类型" />
            <span
              @click="AddChongqing"
              style="display: inline-block; width: 50px; cursor: pointer"
              >添加</span
            >
          </div>
        </div>
      </div>
      <div class="plant-deal-content-wrapper">
        <div class="wrapper-title">
          <div style="margin-left: 1.8vw">备注：</div>
          <div class="text-wrapper">
            <label>
              <textarea v-model="inputValue.remark" rows="5"></textarea>
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DropDown from "../../../components/DropDownSingleDel.vue";
import LoadingTreeStack from "../../../components/LoadingTreeStack.vue";
import TreeSingle from "../../../components/TreeSingle.vue";
import DropDownInput from "../../../components/DropDownInput.vue";
import { userList } from "../../../api/system";
import {
  addBoard,
  selectPestType,
  addTypeChongqing,
} from "../../../api/maintain";
import {
  noEmpty,
  NonChineseInput,
  positiveInteger,
} from "../../../tools/methods";
export default {
  name: "NewPlant",
  components: { DropDown, LoadingTreeStack, TreeSingle, DropDownInput },
  data() {
    return {
      moduleType: "-1",
      typeData: [],
      inputValue: {
        boardType: "",
        pestBoardId: "",
        principalId: "",
        principalName: "",
        remark: "",
        siteId: "",
        siteName: "",
        siteType: "",
        useDays: "",
      },
      delflag: true,
      boardname: "",
      boardnameType: "",
      custodianValue: [],
      showSelect: false,
    };
  },
  created() {
    this.handleSearchValue();
  },
  methods: {
    backPath: function () {
      this.$router.go(-1);
    },
    mouseOver: function () {
      this.showSelect = true;
      selectPestType()
        .then((res) => {
          console.log(res);
          this.typeData = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    AddChongqing: function () {
      let body = {
        pestType: this.boardnameType,
      };
      addTypeChongqing(body)
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.$message({
              message: "添加成功",
              type: "warning",
              center: "true",
              duration: "1000",
            });
            this.typeData = res.data;
          } else {
            this.$message({
              message: res.message,
              type: "warning",
              center: "true",
              duration: "1000",
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    clearinputSelect: function () {
      // selectPestType()
      //   .then((res) => {
      //     console.log(res);
      //     this.typeData = res.data;
      //   })
      //   .catch((err) => {
      //     console.log(err);
      // });
      this.boardname = "";
      this.inputValue.boardType = "";
      this.showSelect = false;
    },
    showInfoType: function (data) {
      // console.log(data.index);
      // console.log(this.typeData);
      // console.log(this.typeData.splice(data.index,0));
      // this.typeData=this.typeData.splice(data.index,0);
      if (data.name != undefined) {
        if (this.inputValue.boardType != "") {
          let arrSame = this.inputValue.boardType.split(",");
          let _this = this;
          let falgee = false;
          console.log(arrSame.length)
          for (var i = 0; i < arrSame.length; i++) {
            if (arrSame[i] == data.name) {
              falgee = true;
            }
          }
          if (falgee) {
            _this.inputValue.boardType = _this.inputValue.boardType;
          } else {
            _this.inputValue.boardType =
              _this.inputValue.boardType + "," + data.name;
            _this.boardname = _this.boardname + "," + data.name;
          }
        } else {
          this.inputValue.boardType = data.name;
          this.boardname = data.name;
        }
      }
      this.showSelect = false;
    },
    showDropSite: function (data) {
      this.inputValue.siteName = data.name;
      this.inputValue.siteId = data.id;
      this.inputValue.siteType = data.siteType;
    },
    showInfo: function (data) {
      this.inputValue.principalId = data.id;
      this.inputValue.principalName = data.name;
      console.log(data);
    },
    sendValue: function (value) {
      console.log(value);
      this.handleSearchValue(value);
    },
    handleSearchValue: function (value) {
      let body = {
        keywork: value,
        page: 1,
        rows: 9999,
      };
      userList(body)
        .then((res) => {
          console.log(res);
          this.custodianValue = res.data.rows;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleData: function () {
      if (
        NonChineseInput(
          this.inputValue.pestBoardId,
          "请输入虫情板ID",
          "虫情板ID不可输入中文",
          ""
        ) &&
        noEmpty(this.inputValue.boardType, "请选择虫情类型", "") &&
        noEmpty(this.inputValue.siteId, "请选择位置", "") &&
        noEmpty(this.inputValue.principalId, "请选择负责人", "") &&
        positiveInteger(this.inputValue.useDays, "请输入使用正整数的天数", "")
      ) {
        let body = this.inputValue;
        console.log(body);
        addBoard(body)
          .then((res) => {
            console.log(res);
            if (res.code === 500) {
              this.$message({
                message: res.message,
                type: "warning",
                center: "true",
                duration: "1000",
              });
            } else {
              this.$message({
                message: res.data,
                type: "warning",
                center: "true",
                duration: "1000",
              });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
  },
};
</script>

<style scoped>
@import "Plant.css";
</style>



// WEBPACK FOOTER //
// src/page/maintain/plant/NewPlant.vue